export const FETCH = "FETCH"
export const CREATE = "CREATE" 
export const UPDATE = "UPDATE"
export const DELETE = "DELETE"

export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
export const NEWAUTH = 'NEWAUTH'

//export const UPDATEUSER = 'UPDATEUSER'